import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";

const mutations: ExMutationTree<State, Mutations> = {
  updateAlertView(state, payload) {
    state.alertView = payload;
  },
  updateApiError(state, payload) {
    state.apiError = payload;
  },
  resetApiError(state) {
    state.apiError = { code: undefined, message: "" };
  },
  updateGrpcError(state, payload) {
    state.grpcError = payload;
  },
  resetGrpcError(state) {
    state.grpcError = { code: undefined, message: "" };
  }
};

export default mutations;
